import * as React from "react";
import Rating from "@mui/material/Rating";
import Box from "@mui/material/Box";
import StarIcon from "@mui/icons-material/Star";
import "./styles.scss";
import { RatingLabels } from "../../types/Types";

type StringMap = {
  [index: string]: string;
};

export type RatingProps = {
  ratingLabels: RatingLabels;
  onRate: (score: number) => void;
};

export default function HoverRating(props: RatingProps) {
  const [value, setValue] = React.useState<number | null>(0);
  const [hover, setHover] = React.useState(-1);

  const [labels, setLabels] = React.useState<StringMap>({ 0: "" });

  React.useEffect(() => {
    const { useless, poor, ok, good, excellent } = props.ratingLabels;
    setLabels({
      1: `${useless}`,
      2: `${poor}`,
      3: `${ok}`,
      4: `${good}`,
      5: `${excellent}`,
    });
  }, [props.ratingLabels]);

  const getLabelText = (value: number) => {
    return `${value} Star${value !== 1 ? "s" : "..."}, ${labels[value]}`;
  };

  return (
    <Box
      sx={{
        width: 200,
        display: "flex",
        alignItems: "center",
      }}
    >
      <Rating
        name="hover-feedback"
        value={value}
        precision={1}
        getLabelText={getLabelText}
        onChange={(event, newValue) => {
          setValue(newValue);
          props.onRate(newValue || 0);
        }}
        emptyIcon={<StarIcon style={{ opacity: 0.75 }} fontSize="inherit" />}
      />
      {value !== null && (
        <Box sx={{ ml: 2 }}>{labels[hover !== -1 ? hover : value]}</Box>
      )}
    </Box>
  );
}
